function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.748047 12.0004C0.748047 11.5862 1.08386 11.2504 1.49811 11.2504H2.77025C3.1845 11.2504 3.52032 11.5862 3.52032 12.0004C3.52032 12.4146 3.1845 12.7504 2.77025 12.7504H1.49811C1.08386 12.7504 0.748047 12.4146 0.748047 12.0004Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4833 12.0004C13.4833 11.5862 13.8191 11.2504 14.2333 11.2504H15.5019C15.9161 11.2504 16.2519 11.5862 16.2519 12.0004C16.2519 12.4146 15.9161 12.7504 15.5019 12.7504H14.2333C13.8191 12.7504 13.4833 12.4146 13.4833 12.0004Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.748047 14.9997C0.748047 14.5855 1.08386 14.2498 1.49811 14.2498H15.4819C15.8961 14.2498 16.2319 14.5855 16.2319 14.9997C16.2319 15.4139 15.8961 15.7497 15.4819 15.7497H1.49811C1.08386 15.7497 0.748047 15.4139 0.748047 14.9997Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.94027 9.34911C6.64281 8.64575 7.59588 8.25043 8.58985 8.25043C9.58382 8.25043 10.5369 8.64575 11.2394 9.34911C11.9419 10.0524 12.3364 11.0062 12.3364 12.0004C12.3364 12.4146 12.0006 12.7504 11.5864 12.7504C11.1721 12.7504 10.8363 12.4146 10.8363 12.0004C10.8363 11.4033 10.5994 10.8309 10.178 10.409C9.75662 9.98718 9.18533 9.75036 8.58985 9.75036C7.99436 9.75036 7.42307 9.98718 7.00171 10.409C6.58031 10.8309 6.34339 11.4033 6.34339 12.0004C6.34339 12.4146 6.00758 12.7504 5.59333 12.7504C5.17908 12.7504 4.84326 12.4146 4.84326 12.0004C4.84326 11.0062 5.23775 10.0524 5.94027 9.34911Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.03996 6.19552C3.34645 5.91687 3.82083 5.93941 4.09952 6.24586L5.00274 7.23907C5.28142 7.54553 5.25888 8.01985 4.95239 8.29849C4.6459 8.57714 4.17152 8.5546 3.89283 8.24815L2.98961 7.25494C2.71093 6.94849 2.73347 6.47417 3.03996 6.19552Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8932 6.19552C14.1997 6.47417 14.2222 6.94849 13.9435 7.25494L13.0403 8.24815C12.7616 8.5546 12.2873 8.57714 11.9808 8.29849C11.6743 8.01985 11.6517 7.54553 11.9304 7.23907L12.8336 6.24586C13.1123 5.93941 13.5867 5.91687 13.8932 6.19552Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.63526 0.250427C9.04951 0.250427 9.38533 0.586199 9.38533 1.0004V5.89986C9.38533 6.31405 9.04951 6.64983 8.63526 6.64983C8.22101 6.64983 7.88519 6.31405 7.88519 5.89986V1.0004C7.88519 0.586199 8.22101 0.250427 8.63526 0.250427Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.58854 2.54566C5.89521 2.26721 6.36958 2.29005 6.64807 2.59669L8.63548 4.78498L10.6229 2.59669C10.9014 2.29005 11.3758 2.26721 11.6824 2.54566C11.9891 2.82411 12.012 3.29841 11.7335 3.60504L9.19077 6.40474C9.0486 6.56127 8.84695 6.65053 8.63548 6.65053C8.42401 6.65053 8.22237 6.56127 8.0802 6.40474L5.5375 3.60504C5.25902 3.29841 5.28187 2.82411 5.58854 2.54566Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.0014,
  height: 15.9993,
  fill: "white",
  transform: "translate(0.499268 0.000366211)"
})));

var SvgSunset = function SvgSunset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSunset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sunset.2b3d757f.svg";
export { ForwardRef as ReactComponent };